import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import TextFieldWithLabel from "../../components/TextFieldWithLabel";
import { useFetchApi } from "../../hooks/useFetchApi";

const AddNewModal: React.FC<{
  status: boolean;
  onClose: any;
  onSuccess?: any;
  data?: any;
}> = ({ status, onClose, onSuccess, data = {} }): React.ReactElement => {
  console.log({ data });
  const [d, setD] = useState<any>(data || {});
  const { execute } = useFetchApi(
    "/api/stock-markets",
    {},
    data && Object.keys(data).length ? "PUT" : "POST",
    onSuccess
  );

  const handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    setD({ ...d, [id]: value });
  };

  const handleOnSubmit = (e: any) => {
    execute({ ...d, id: data.id ? data.id : undefined });
    const _e = { ...e, target: { ...e.target, id: "newEdit" } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: "newEdit" } };
    onClose(_e);
  };

  useEffect(() => {
    if (data && Object.keys(data).length) {
      setD(data);
    }

    return () => {
      setD({});
    };
  }, [data]);

  return (
    <Modal
      heading="Add/Edit Stock Market"
      status={status}
      onClose={handleClose}
      onSubmit={handleOnSubmit}
    >
      <TextFieldWithLabel
        id="market_name"
        label="Market name"
        value={d.market_name}
        onChange={handleChange}
      />
      <TextFieldWithLabel
        id="short_name"
        label="Short name"
        value={d.short_name}
        onChange={handleChange}
      />
      <TextFieldWithLabel
        id="currency"
        label="Currency e.g (USD,LKR)"
        value={d.currency}
        onChange={handleChange}
      />
      <div className="flex w-full flex-col pb-2">
        <label className="mb-2">Status</label>
        <select className="w-full border-2 rounded" onChange={handleChange} id="status">
          <option value="1" selected={d.status === 1}>Active</option>
          <option value="0" selected={d.status === 0}>Inactive</option>
        </select>
      </div>
    </Modal>
  );
};

export default AddNewModal;
